<template>
    <section class="hero is-fullheight">
        <div class="hero-body">
            <div class="container has-text-centered">
                <div class="column is-4 is-offset-4">
                    <div class="logo"><img src="../../assets/logo.png"> </div>
                    <p class="subtitle has-text-white">Create a free account and get full access to the car auctions in Japan.</p>
                    <div class="box">
                        <form>
                            <div class="field">
                                <div class="control">
                                    <input v-model="user.name"
                                           v-bind:class="{ 'is-danger': error.errors.name }"
                                           class="input"
                                           type="text"
                                           placeholder="Full name"
                                           required=""
                                           autofocus="">
                                    <p v-if="error.errors.name" class="help is-danger">{{ error.errors.name[0] }}</p>
                                </div>
                            </div>
                            <div class="field">
                                <div class="control">
                                    <input v-model="user.email"
                                           v-bind:class="{ 'is-danger': error.errors.email }"
                                           class="input"
                                           type="email"
                                           placeholder="Email"
                                           required=""
                                           autofocus="">
                                    <p v-if="error.errors.email" class="help is-danger">{{ error.errors.email[0] }}</p>
                                </div>
                            </div>
                            <div class="field">
                                <div class="control">
                                    <input v-model="user.phone"
                                           v-bind:class="{ 'is-danger': error.errors.phone }"
                                           class="input"
                                           type="text"
                                           placeholder="Phone"
                                           required=""
                                           autofocus="">
                                    <p v-if="error.errors.phone" class="help is-danger">{{ error.errors.phone[0] }}</p>
                                </div>
                            </div>
                            <div class="field">
                                <div class="control">
                                    <input v-model="user.password"
                                           v-bind:class="{ 'is-danger': error.errors.password }"
                                           class="input"
                                           type="password"
                                           required=""
                                           placeholder="Password">
                                    <p v-if="error.errors.password" class="help is-danger">{{ error.errors.password[0] }}</p>
                                </div>
                            </div>
                            <div class="field">
                                <div class="control">
                                    <input v-model="user.password_confirmation"
                                           v-bind:class="{ 'is-danger': error.errors.password_confirmation }"
                                           class="input"
                                           type="password"
                                           required=""
                                           placeholder="Confirm Password">
                                    <p v-if="error.errors.password_confirmation" class="help is-danger">{{ error.errors.password_confirmation[0] }}</p>
                                </div>
                            </div>
                            <div class="field">
                                <div class="control has-icons-left">
                                    <div class="select is-fullwidth">
                                        <select v-model="user.type" v-on:change="userType(user.type)" v-bind:class="{ 'is-danger': error.errors.type }">
                                            <option :value="this.$userTypeIndividual">Individual</option>
                                            <option :value="this.$userTypeProfessional">Professional</option>
                                            <option :value="this.$userTypeOther">Other</option>
                                        </select>
                                    </div>
                                    <span class="icon is-left">
                                        <i class="fas fa-user"></i>
                                    </span>
                                    <p v-if="error.errors.type" class="help is-danger">{{ error.errors.type[0] }}</p>
                                </div>
                            </div>
                            <div v-if="isProfessional" class="field">
                                <div class="control">
                                    <input v-model="user.company"
                                           v-bind:class="{ 'is-danger': error.errors.company }"
                                           class="input"
                                           type="text"
                                           required=""
                                           placeholder="Company name">
                                    <p v-if="error.errors.company" class="help is-danger">{{ error.errors.company[0] }}</p>
                                </div>
                            </div>
                            <div class="field">
                                <div class="control has-icons-left">
                                    <div class="select is-fullwidth" v-bind:class="{ 'is-danger': error.errors.country }">
                                        <select v-model="user.country">
                                            <option value="" hidden disabled>Country</option>
                                            <option v-for="country in countries">{{ country.name }}</option>
                                        </select>
                                    </div>
                                    <span class="icon is-left">
                                        <i class="fas fa-globe"></i>
                                    </span>
                                    <p v-if="error.errors.country" class="help is-danger">{{ error.errors.country[0] }}</p>
                                </div>
                            </div>
                            <button @click.prevent="register" class="button is-block is-primary is-large is-fullwidth">Register</button>
                        </form>
                    </div>
                    <div class="social-logins">
                        <facebook-login class="button"
                                        appId="597797607469702"
                                        @login="getUserData"
                                        @logout="onLogout"
                        >
                        </facebook-login>

                        <GoogleLogin :params="params" :renderParams="renderParams" :onSuccess="onSuccess" :onFailure="onFailure"></GoogleLogin>
                    </div>
                    <p class="has-text-white">
                        <b>If already registered. Please login <router-link to="/login" class="has-text-white link">here.</router-link></b>
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import apiUsers from '../../api/apiUsers'
    import apiAuth from '../../api/apiAuth'
    import axios from 'axios'
    import facebookLogin from 'facebook-login-vuejs'
    import GoogleLogin from 'vue-google-login';
    export default {
        components: {
            facebookLogin,
            GoogleLogin
        },
        data() {
            return {
                countries: [],
                professional: false,
                user: {
                    name: '',
                    email: '',
                    phone: '',
                    type: this.$userTypeIndividual,
                    company: '',
                    country: '',
                    password: '',
                    password_confirmation: '',
                    role: 'Visitor'
                },
                error: {
                    message: '',
                    errors: {
                        name: '',
                        email: '',
                        phone: '',
                        type: '',
                        company: '',
                        country: '',
                        password: '',
                        password_confirmation: ''
                    }
                },
                params: {
                    client_id: "857305155291-7b0rk496pnj0mk0ba66f311s977k70be.apps.googleusercontent.com"
                    //client_id: "795399958520-7aignerg3b4f3m19la81ciisto8n7vpn.apps.googleusercontent.com"
                },
                // only needed if you want to render the button with the google ui
                renderParams: {
                    width: 225,
                    height: 36,
                    longtitle: true
                }

            }
        },
        computed: {
           isProfessional () {
               return this.professional
           }
        },
        methods: {
            userType(type) {
                this.professional = type === this.$userTypeProfessional;

            },
            register() {
                this.clearAllErrors()
                apiUsers.signUpRequest(this.user, this.$route.query.referer)
                    .then((response) => {
                        this.$store.commit('updateToken', response.data.token)
                        this.$store.commit('updateRole', 'Visitor')
                        //this.$store.commit('updateUserReferer', (response.data.user.affiliate_id || response.data.role == 'Affiliate') ? 1 : 0 )
                        this.$store.commit('updateUserName', response.data.user.name)
                        this.$router.push({ path: '/system' })
                    })
                    .catch((err) => {
                        if ( err.response && err.response.status === 422 ) {
                            this.error.message = err.response.statusText
                            this.error.errors = err.response.data.errors
                        } else {
                            this.error.message = 'Connection error!'
                        }
                    })
            },
            clearAllErrors() {
                this.error.errors = {
                    message: '',
                    errors: {
                        name: '',
                        email: '',
                        phone: '',
                        type: '',
                        company: '',
                        country: '',
                        password: '',
                        password_confirmation: ''
                    }
                }
            },
            getUserData(response) {
                console.log(response);
                var token = response.response.authResponse.accessToken;
                var userid = response.response.authResponse.userID;
                apiAuth.socialLoginRequest({type: 'facebook', token: token, facebook_id: userid})
                    .then((response) => {
                        if(response.data.details) {
                            this.$store.commit('updateToken', response.data.token)
                            this.$store.commit('updateRole', 'Visitor')
                            //this.$store.commit('updateUserReferer', (response.data.referer || response.data.role == 'Affiliate') ? 1 : 0 )
                            this.$store.commit('updateUserName', response.data.user.name)
                            this.$router.push({path: '/system'})
                        }else {
                            this.$store.commit('updateToken', response.data.token)
                            this.$store.commit('updateRole', response.data.role)
                            //this.$store.commit('updateUserReferer', (response.data.referer || response.data.role == 'Affiliate') ? 1 : 0 )
                            this.$store.commit('updateUserName', response.data.name)
                            this.$store.dispatch('setCurrentUserCarHiddenFields', response.data.car_hidden_fields)
                            this.$store.commit('updateUserDeposit', response.data.deposit)
                            this.$store.commit('updateUserDepositRate', response.data.rate)
                            this.$store.commit('updateUserManagerGoal', response.data.manager_goal)
                            this.$store.dispatch('fetchCurrentUserManagerGoalAchieved');
                            this.$router.push({path: '/system'})
                        }
                    })
                    .catch((err) => {
                        this.error.status = true
                        if ( err.response && err.response.status === 422 ) {
                            this.error.message = 'Wrong credentials!'
                            this.error.errors = err.response.data.errors
                        } else {
                            this.error.message = err.response.data.errors
                        }
                    })
                console.log(response)
            },
            onLogout() {
                console.log('logout')
            },
            onSuccess(googleUser) {
                console.log(googleUser);
                var profile = googleUser.getBasicProfile();
                var google_id = profile.getId();
                apiAuth.socialLoginRequest({type: 'google', google_id: google_id, name: profile.getName(), email: profile.getEmail()})
                    .then((response) => {
                        if(response.data.details) {
                            this.$store.commit('updateToken', response.data.token)
                            this.$store.commit('updateRole', 'Visitor')
                            this.$store.commit('updateUserName', response.data.user.name)
                            this.$router.push({path: '/system'})
                        }else {
                            this.$store.commit('updateToken', response.data.token)
                            this.$store.commit('updateRole', response.data.role)
                            this.$store.commit('updateUserName', response.data.name)
                            this.$store.dispatch('setCurrentUserCarHiddenFields', response.data.car_hidden_fields)
                            this.$store.commit('updateUserDeposit', response.data.deposit)
                            this.$store.commit('updateUserDepositRate', response.data.rate)
                            this.$store.commit('updateUserManagerGoal', response.data.manager_goal)
                            this.$store.dispatch('fetchCurrentUserManagerGoalAchieved');
                            this.$router.push({path: '/system'})
                        }
                    })
                    .catch((err) => {
                        this.error.status = true
                        if ( err.response && err.response.status === 422 ) {
                            this.error.message = 'Wrong credentials!'
                            this.error.errors = err.response.data.errors
                        } else {
                            this.error.message = err.response.data.errors
                        }
                    })
            },
            onFailure(data) {
                console.log(data)
                alert('Google login not working');
            }
        },
        mounted () {
            axios.get('https://restcountries.com/v3.1/all?fields=name')
                .then((response) => {
                    this.countries = response.data
                })
        }
    }
</script>

<style scoped>
        .hero {
            background: url("../../assets/fuji.jpeg") no-repeat center center fixed;
            -webkit-background-size: cover;
            -moz-background-size: cover;
            -o-background-size: cover;
            background-size: cover;
        }
        .link {
            border-bottom: 1px solid blue;
        }
        .social-logins .container.button {
            width: auto;
            padding: 0;
            background: transparent;
            border: 0;
            margin: 0;
        }
        .logo {
            width: 120px;
            text-align: center;
            margin: auto;
        }
</style>




// WEBPACK FOOTER //
// src/components/Auth/Register.vue